import { render, staticRenderFns } from "./recycle-bin.vue?vue&type=template&id=471626ae&scoped=true&"
import script from "./recycle-bin.vue?vue&type=script&lang=js&"
export * from "./recycle-bin.vue?vue&type=script&lang=js&"
import style0 from "./recycle-bin.vue?vue&type=style&index=0&id=471626ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471626ae",
  null
  
)

export default component.exports